import axios from "axios";
import { getApiDomain } from "@/config/app.config";

const isBrowser = typeof window !== "undefined";

const apiBase = axios.create({
  // Browser usa proxy same-origin (/api) para evitar bloqueio de cookies de terceiros no Safari.
  baseURL: isBrowser ? "/api/" : getApiDomain(),
  timeout: 6000,
  withCredentials: true,
});

export default apiBase;
